module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"culture":"en-CA"},"fr":{"culture":"fr-CA"}}')
  delete Component.options._Ctor
}
